import React from "react";
import style from "./expect.module.scss";
import arrow1 from "./img/arrow_1.png";
import arrow1_xl from "./img/arrow_1_xl.png";
import arrow1_md from "./img/arrow_1_md.png";
import arrow2 from "./img/arrow_2.png";
import arrow2_md from "./img/arrow_2_md.png";
import arrow2_lg from "./img/arrow_2_lg.png";
import arrow2_xl from "./img/arrow_2_xl.png";
import arrow3 from "./img/arrow_3.png";
import arrow3_md from "./img/arrow_3_md.png";
import arrow3_lg from "./img/arrow_3_lg.png";
import arrow3_xl from "./img/arrow_3_xl.png";
import arrow4 from "./img/arrow_4.png";
import arrow4_md from "./img/arrow_4_md.png";
import arrow4_lg from "./img/arrow_4_lg.png";
import arrow4_xl from "./img/arrow_4_xl.png";
import arrow5 from "./img/arrow_5.png";
import arrow5_md from "./img/arrow_5_md.png";
import arrow5_lg from "./img/arrow_5_lg.png";
import arrow5_xl from "./img/arrow_5_xl.png";

function Expect() {

  return (
    <div className={style.expect}>
      <div className="container">
        <div className={style.expect__content}>
          <h2 className={style.expect__contentTitle}>Here is what you can expect from our first appointment</h2>
          <div className={style.expect__contentBody}>
            <ol>
              <li>
                <div className={style.expect__contentTextLeft}>
                  <h3>1</h3>
                  <p >We will spend 15-30 minutes going over your medical
                    history and reviewing all information relevant to your main health concern. All information, tests
                    results, doctors’ notes, and your own understanding of what is going on in your body is relevant and
                    important
                  </p>
                </div>
              </li>
              <li>
                <div className={style.expect__contentTextRight}>
                  <picture>
                    <source media="(min-width:1140px)" srcSet={arrow1_xl}/>
                    <source media="(min-width:992px)" srcSet={arrow1_xl}/>
                    <source media="(min-width: 768px)" srcSet={arrow1_md}/>
                    <img className={style.expect__contentArrow1} src={arrow1} alt="arrow1" width="187px" height="251px"/>
                  </picture>
                  <h3>2</h3>
                  <p>We will spend 15-30 minutes talking about all your body systems, literally head-to-toe. Chinese
                    medicine focuses on treating the whole person and all body systems have to contribute to your
                    overall well-being
                  </p>
                </div>

              </li>
              <li>
                <div className={style.expect__contentTextLeft}>
                  <picture>
                    <source media="(min-width:1140px)" srcSet={arrow2_xl}/>
                    <source media="(min-width:992px)" srcSet={arrow2_lg}/>
                    <source media="(min-width: 768px)" srcSet={arrow2_md}/>
                    <img className={style.expect__contentArrow2} src={arrow2} alt="arrow2" width="115px" height="231px"/>
                  </picture>
                  <h3>3</h3>
                  <p>I will perform a diagnostic check of your pulses on both
                    hands and your tongue. Qualities of your pulses, shape, color, coating of your tongue all offer
                    valuable diagnostic tools
                  </p>
                </div>
              </li>
              <li>
                <div className={style.expect__contentTextRight}>
                  <picture>
                    <source media="(min-width:1140px)" srcSet={arrow3_xl}/>
                    <source media="(min-width:992px)" srcSet={arrow3_lg}/>
                    <source media="(min-width: 768px)" srcSet={arrow3_md}/>
                    <img className={style.expect__contentArrow3} src={arrow3} alt="arrow3" width="338px" height="157px"/>
                  </picture>
                  <h3>4</h3>
                  <p>I will gently palpate your abdomen for any sensitivities
                    or pain
                  </p>
                </div>
              </li>
              <li>
                <div className={style.expect__contentTextLeft}>
                  <picture>
                    <source media="(min-width:1140px)" srcSet={arrow4_xl}/>
                    <source media="(min-width:992px)" srcSet={arrow4_lg}/>
                    <source media="(min-width: 768px)" srcSet={arrow4_md}/>
                    <img className={style.expect__contentArrow4} src={arrow4} alt="arrow4" width="248px" height="196px"/>
                  </picture>
                  <h3>5</h3>
                  <p>Our conversation and checking your tongue, pulse, and
                    abdomen will help me build a diagnosis and a treatment strategy</p>
                </div>
              </li>
              <li>
                <div className={style.expect__contentTextRight}>
                  <picture>
                    <source media="(min-width:1140px)" srcSet={arrow5_xl}/>
                    <source media="(min-width:992px)" srcSet={arrow5_lg}/>
                    <source media="(min-width: 768px)" srcSet={arrow5_md}/>
                    <img className={style.expect__contentArrow5} src={arrow5} alt="arrow5" width="181px" height="153px"/>
                  </picture>
                  <h3>6</h3>
                  <p>You will receive your first acupuncture treatment and we
                    will plan your consecutive treatments</p>
                </div>
              </li>
            </ol>
          </div>
        </div>
      </div>

      <div className={style.expect__bgImg}>
      </div>
    </div>
  )
}

export default Expect;